'use strict';
import video from '../../../video';
import util from '../../../util';

let videoplayer = null;
const isTablet = window.matchMedia('(max-width: 768px)').matches;
const windowHeight = $(window).height();


// Product slider
function initProductSliderHandler() {

    let slider = $(".pdp-main >.experience-main-productdetail #thumbnails .product-images");

    $('.pdp-page #header-bottom-notification-message').length && $('.product-image-container .product-thumbnails').addClass('btm-notif');

    // If the slider is not initialized, initialize it
    if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick({
            initialSlide: 0,
            autoplay: false,
            arrows: false,
            infinite: false,
            fade: true,
            speed: 200,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        fade: false,
                        speed: 300,
                        dots: true
                    }
                }
            ]
        }); // Initialize the Slick slider
    }

    // Load the thumbnails only if the page is a PDP page
    $('.pdp-page').length && loadThumbnails(); 

    //  Added unique ID to each video element
    calculateImageContainerWidth();

    initPinchZoomOnTablet();
}

/**
 * Retrieves the URL for a product image based on the given view type.
 *
 * @param {string} viewType - The type of view for which to retrieve the image URL.
 * @return {string} The URL for the product image of the given view type.
 */
function getProductImageURL(viewType) {
    var pid = $("span[data-productid='productID']").data("pid");
    return util.appendParamsToUrl(Urls.getProductImages, {
        "pid": pid,
        "sz": viewType
    });
}

/**
 * Load product thumbnail images asynchronously and initialize the thumbnail carousel.
 *
 * This function retrieves the URL for product thumbnail images based on the "thumbnail" view type.
 * It then asynchronously loads the images using jQuery's `$.get` method and inserts the result into the DOM element with the ID "pdp-thumbnails-image".
 * `initThumbnailCarousel` function is called to initialize the thumbnail carousel.
 *
 * @return {void} This function does not return anything.
 */
function loadThumbnails() {
    var viewType = "thumbnail";
    var thumbnailProductImageURL = getProductImageURL(viewType);

    $.get(thumbnailProductImageURL).done(function (res) {
        $("#pdp-thumbnails-image").html(res);
        $('#pdp-thumbnails-image .video-thumbnail-image').remove();
        initThumbnailCarousel();

    });
}

/**
 * Initializes the thumbnail carousel on the product page.
 *
 * This function sets up the thumbnail carousel on the product page. It retrieves the main image slider and thumbnail slider elements from the DOM.
 * It then initializes the thumbnail slider
 * It also sets up event listeners for the main image slider and thumbnail slider to handle beforeChange events and click events on thumbnail slides.
 * The event listeners ensure that the main image slider and thumbnail slider are synchronized.
 *
 * @return {void} This function does not return anything.
 */
function initThumbnailCarousel() {

    var mainImageSlider = $('#thumbnails ul.product-images'),
        thumbnailSlider = $('.pdp-product-thumbnail-slider');

    $(thumbnailSlider).not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: getSlidesToShow(windowHeight),
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        accessibility: false,
        variableWidth: false,
        nextArrow: '<button class="icon slick-next slick-arrow"><i class="icon-angle-right"></i></button>',
        prevArrow: '<button class="icon slick-prev slick-arrow"><i class="icon-angle-left"></i></button>',
    });

    function getSlidesToShow(height) {
        if (height > 850) return 7;
        if (height > 650) return 5;
        if (height > 500) return 4;
        return 2;
    }
    let isHovering = false; 
    var active = false;
    $(mainImageSlider).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        active = true;
        if (!isHovering) { // Prevent scrolling if hovering over the thumbnail slider
            thumbnailSlider.slick("slickGoTo", nextSlide);
        }
        $(".slick-slide", thumbnailSlider).removeClass("clicked-slide");
        $(".slick-slide.slick-current", thumbnailSlider).removeClass("slick-current");
        $(".slick-slide[data-slick-index=" + nextSlide + "]", thumbnailSlider).addClass("slick-current");
    });

    $(thumbnailSlider).hover(
        function () {
            isHovering = true; // Set flag to prevent scrolling
            $(this).slick('slickPause'); // Optionally pause the slider
        },
        function () {
            isHovering = false; // Reset flag when hover ends
        }
    );

    $(thumbnailSlider).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        active = true;
        $(mainImageSlider).slick("slickGoTo", nextSlide);
    });
    $(thumbnailSlider).on('click', '.slick-slide', function () {
        active = true;
        $(mainImageSlider).slick("slickGoTo", $(this).data("slickIndex"));
        $(".slick-slide.slick-current", $(thumbnailSlider)).removeClass("slick-current");

    });
}

/**
 * On tablet devices, the product slider and video thumbnails
 * are not fully rendered at the time the page is loaded,
 * therefore we delay the pinch zoom initialisation until
 * after a small delay (2 seconds) to ensure they are fully
 * rendered and can be zoomed in
 */

function initPinchZoomOnTablet() {
    if (isTablet) {

        $('.pinch-zoom').each(function () {
            var $this = $(this),
                pinchImage = $this.attr('data-lgimg');

            $this.parent().parent().css({
                'background-image': 'url(' + pinchImage + ')',
                'background-repeat': 'no-repeat',
            }).addClass('pinch-zoom-image');
        });

        $(document).on('click', '.product-images .slick-slide.slick-current.slick-active > div', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();

            var $this = $(this);

            var x = evt.offsetX / $this.width() * 100;
            var y = evt.offsetY / $this.height() * 100;

            $this.css('background-position', x + '% ' + y + '%');

            $this.find('img').toggleClass('opacity-none');
        });

        $('.product-image-container .product-images').on('afterChange', function () {
            $(this).find(".slick-slide img").removeClass('opacity-none');
        });
    }
}

function productSliderVideoThumbnail(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    
    const slickIndex = $(evt.target).closest('.slick-slide').data('slick-index');
    // Flag to track if video has been played
    let videoPlayed = false,
        $videoThumbnailWrappers = $('.video-thumbnail-wrapper'),
        $videoThumbnailWrapper = $('.product-images-wrapper .slick-slide[data-slick-index="' + slickIndex + '"]').find('.video-thumbnail-wrapper'),
        video = $videoThumbnailWrappers.find('.product-vid'),
        slickSlide = $('#pdp-thumbnails-image .slick-slide'),
        videos = $videoThumbnailWrappers.find('video');
        
    // Check if the product page is the PDP redesign and has video thumbnails
    if ($videoThumbnailWrappers.length > 0) {
        //  Added unique ID to each video elements
        $('.productthumbnail .video-thumbnail-wrapper').parent().addClass('video-thumbnail');
        $videoThumbnailWrappers.find('.product-vid').each(function (index) {
            $(this).attr('id', 'thumnailvideo_' + index);
        });

        setTimeout(() => {
            // Custom Video pause on change of thumbnail, Show poster & Play Icon
            slickSlide.off('mouseenter.videoReset').on('mouseenter.videoReset', function () {
                customVideoReset();
            });

            $('.product-image-container .product-images').off('afterChange.videoReset').on('afterChange.videoReset', function () {
                customVideoReset();
            });

            $('.product-image-container .product-thumbnails .slick-arrow').off('click.videoReset').on('click.videoReset', function () {
                customVideoReset();
            });

            function customVideoReset() {
                if (videoPlayed) {
                    videoPlayed = false; // Update the flag for video has been played
                    $videoThumbnailWrapper.find('.vid-thumbnail-play-btn').removeClass('in-active');
                    $videoThumbnailWrapper.find('img.poster').removeClass('in-active');
                    $videoThumbnailWrapper.find('video').removeClass('active');
                    videos.each(function (index, video) {
                        if (!video.paused) {
                            video.pause();
                            video.currentTime = 0;
                        }
                    });
                }
            }
        }, 500);

    }

    if (!$videoThumbnailWrapper.find('.vid-thumbnail-play-btn').length) {
        return false;
    } else {
        if (!videoPlayed) {
            const videoID = $videoThumbnailWrapper.find('.product-vid').attr('id').split('_');
            const videoElement = document.getElementById('thumnailvideo_' + videoID[1]);
            if (!videoElement) return;

            $videoThumbnailWrapper.find('.vid-thumbnail-play-btn').addClass('in-active');
            $videoThumbnailWrapper.find('img.poster').addClass('in-active');
            $videoThumbnailWrapper.find('video').addClass('active');

            videoElement.pause();
            videoElement.currentTime = 0;

            const playPromise = videoElement.play();
            if (playPromise !== undefined) {
                playPromise.catch(err => {
                    console.warn('Blocked play:', err);
                });
            }
            videoPlayed = true;
        }
    }

    // Initialize the video player
    video.init(function () {
        /**
         * Add event to reset & set the video player
         * on change of the main image slider
         */
        $(document).on('afterChange', '.slick-slider.product-images', function (event, slick, currentSlide) {
            var currentSlide = $(this).find(".slick-slide").eq(currentSlide);
            resetVideoPlayer();
            setVideoPlayer(currentSlide.find('.product-video'));
            setVideoHeight();
        });
    });
}

/**
 * Reset the video player by destroying it
 */
function resetVideoPlayer() {
    if (videoplayer) {
        videoplayer.destroy();
        videoplayer = null;
    }
    
    $('.product-image-container').off('click.videoThumbnail')
    .on('click.videoThumbnail', '.pdp-thumbnail-slide.video-thumbnail, .product-images .slick-slide.slick-current.slick-active > div', function(evt) {
        productSliderVideoThumbnail(evt);
    });
}

/**
 * Set the video player for the given slide
 */
function setVideoPlayer($slide) {
    if ($slide && $slide.length) {
        var $element = $($slide[0]); // Get the jQuery element for the slide
        var videoID = $element.data('videoid'); // Get the video ID from the slide data

        if (!videoID) { return; } // If there is no video ID, return

        $element.find(".video-wrapper") // Find the video wrapper in the slide
            .html('<div id="videoplayer_pdp"></div>'); // Add a new video player div to the wrapper

        videoplayer = video.playerThumbnail($("#videoplayer_pdp"), videoID); // Set the video player
    }
}

/**
 * Set the height for the video player to match the width of the thumbnail slider
 */
function setVideoHeight() {
    var slider = $("#thumbnails .product-images.slick-initialized"),
        videoPlayer = $("#videoplayer_pdp");

    if (slider.length && videoPlayer.length) {
        if (isTablet) {
            videoPlayer.height(slider.find(".slick-slide").width() - 30); // Set the video player height to match the slide width
            videoPlayer.closest(".slick-slide").css("line-height", "0"); // Set the line height of the slide to 0 to prevent text overlapping the video
        }
    }
}


function handleResize() {
    // Store the window width
    var winWidth = $(window).width();

    $(window).on('resize orientationchange', function () {
        // to prevent calling of resize event while scrolling in IOS devices
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();

            initPinchZoomOnTablet();
            calculateImageContainerWidth();
        }
    });
}

function calculateImageContainerWidth() {
    var imageWidth = $('.pdp-main>.container>.product-content .product-image-container .product-thumbnails .product-images .productthumbnail .pinch-zoom img').outerHeight();
    $('.pdp-main>.container>.product-content .product-image-container .product-thumbnails .product-images-wrapper .productthumbnail').css('width', imageWidth);
}


function headerBottomNotificationMessage() {
    if ($('.pdp-redesign, .quick-shop-panel').length > 0) {
        $('#header-bottom-notification-message .header-bottom-notification-close').on('click', function (e) {
            $('.pdp-main>.container>.product-content .product-image-container .product-thumbnails').removeClass('btm-notif');
            $(".pdp-main>.container>.product-content .product-image-container #thumbnails .product-images").slick('unslick');
            initProductSliderHandler();
        });
    }
}

export default function () {
    resetVideoPlayer();
    initProductSliderHandler();
    handleResize();
    headerBottomNotificationMessage();    
};

export const initProductSlider = initProductSliderHandler;
